import React from 'react'

function CompanyLang() {
  return (
    <div className='banner-content'>
      <h1>WELCOME TO SRISTAR GOLD<br /> {/* // language change here /// */}
        COMPANY</h1>
        <p>ಶಿಕ್ಷಣವಾಗಲಿ ಅಥವಾ ಮರುಪಣದ ಚಿನ್ನವಾಗಲಿ — ನಿಮಗೆ ಯಾವ ಅಗತ್ಯವಿದ್ದರೂ, ನಿಮ್ಮ ಚಿನ್ನಕ್ಕಿಂತ ನಿಮ್ಮ ವಿಶ್ವಾಸವನ್ನೇ ನಾವು ಹೆಚ್ಚು ಮೌಲ್ಯವಾಗಿಸಿಕೊಳ್ಳುತ್ತೇವೆ!</p>
<p>Education and Repledged Gold- whatever your need, we value your trust more than your gold!.</p>
      
      <div className='banner-foot'>
        <a href='/about'>
          <button className="btn btn-home" type="button">About Us</button></a>
        <a href='tel:6366333444'>
          <button className="btn btn-home" type="button">Contact Us</button></a>
      </div>

    </div>
  )
}

export default CompanyLang

